import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDebouncedCallback } from 'use-debounce';
import { useInfinitePlayersOptionsQuery } from './Teams.state';
import { FormAutocompleteMultiple } from "../common/FormAutocomplete";

const TeamSelect = ({ setValue, value, mapLabel = "email", placeholder }) => {
  const { t } = useTranslation();
  const [term, setTerm] = useState('');
  const onRemoteSearch = useDebouncedCallback((query) => {
    setTerm(query);
  }, 600);

  const { players: options, fetchNextPage, isFetching, hasNextPage } = useInfinitePlayersOptionsQuery({ term });

  const onNextPage = useCallback(async () => {
    if (isFetching || !hasNextPage) {
      return;
    }
    await fetchNextPage();
  }, [isFetching, hasNextPage, fetchNextPage]);

  return (
    <FormAutocompleteMultiple
      loading={isFetching}
      options={options}
      mapLabel={mapLabel}
      disableClearable={true}
      size="small"
      placeholder={placeholder || t("Select people...")}
      onChange={(e, value) => {
        setValue(value);
      }}
      value={value}
      onRemoteSearch={onRemoteSearch}
      onNextPage={onNextPage}
      stateful={false}
    />
  );
};

export default TeamSelect; 